import { TextField, Typography } from '@mui/material'
import { type } from '@testing-library/user-event/dist/type'
import React, { Fragment, memo } from 'react'

const CustomTextField = ({id, value, onchange, helperText, errorMsg, title, placeholder,multiple,type}) => {
  return (
  <Fragment>
    <Typography variant='body1' fontSize={17} mb={0.8}>{title}</Typography>
    <TextField 
    id={id}
    name={id}
    value={value}
    onChange={onchange}
    helperText={helperText}
    placeholder={placeholder}
    error={errorMsg}
    size='small'
    fullWidth
    multiline={multiple}
    type={type}
    rows={4}
    inputProps={{
      maxLength: id=='mobile' || id=='phone' ? 10 : undefined,
    }}
    />
    
    </Fragment>
  )
}

export default memo(CustomTextField)